/**
 * 1、柱状图
 * xArray：x轴显示的数组，如：["2018-01","2017-12","2017-11"]
 * xFieldName：分组显示名称字段：如：businessType
 * yData：显示的数据。如：[
 {
     "2017-11":508683,
     "2018-01":10090,
     "2017-12":330426,
     "businessType":"行政使用"
 },
 {
     "2017-11":449583,
     "2018-01":311,
     "2017-12":454406,
     "businessType":"教学使用"
 }
 ]
 * */
const setChartBarLineData = function(xArray,xFieldName,yData,stack){
  //console.log("xArray:"+JSON.stringify(xArray));
  //console.log("yData:"+JSON.stringify(yData));
  var dataBar1 = {};
  //创建x轴
  dataBar1["xAxisData"]=xArray;
  //创建y轴
  var series =[];
  for(let i=0;i<yData.length;i++){
    var data =[];
    for(let j=0;j<xArray.length;j++){
      var key = xArray[j];
      data.splice(j,0,yData[i][key]);
    }
    series.splice(i,0,{
      name:yData[i][xFieldName],
      type:'bar',
      barWidth :20,
      stack:stack,
      data:data
    });
  }
  dataBar1["series"]=series;
  return dataBar1;
};

const setTableTotalData = function(tableData,hang,lie,fieldName){//数据，行合计，列合计
  var reData = tableData;
  var hj_y = new Object();
  hj_y[fieldName] = "合计";//合计字段列的key
  var hj_zj=0;//合计总计
  for(let i=0;i<reData.length;i++){//行合计
    var dataObj = reData[i];
    var dataHj_x=0;//行合计
    for(var j in dataObj) {
      if(this.checkRate(dataObj[j])){//是数字
        dataHj_x+=dataObj[j];//行计算
        if(i===0){
          hj_y[j] = dataObj[j];//列计算
        }else{
          hj_y[j] += dataObj[j];//列计算
        }

      }
      
    }
    if(hang){
      dataObj["hj_x"]=dataHj_x;//添加行合计到对象中
    }
    
    hj_zj +=dataHj_x;//总总计
  }
  hj_y["hj_x"] = hj_zj;//列计算
  if(lie){
    reData.splice(reData.length,0,hj_y);//添加列合计
  }
/*  
  for(var j in hj_y) {
    console.log(j,":",hj_y[j]);

  }*/
  return reData;
};

module.exports = {
  setChartBarLineData:setChartBarLineData,
  setTableTotalData:setTableTotalData,
  checkRate:function (nubmerStr) {
　　var re = /^[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
　　if (!re.test(nubmerStr)) {
　　　　return false;
　　}
    return true;
  } 
}



// WEBPACK FOOTER //
// ./src/utils/ChartsUtils.js